import { Box, Container, Grid } from '@mui/material'
import CustomButton from 'components/Fileds/CustomButton'
import POSHeader from 'components/POSHeader'
import TablesInfoHeader from 'components/TablesInfoHeader'
import React from 'react'
import { ThemeProvider } from 'theme/ThemeContext2'
import "./style.css";
import NoItemsCreated from 'components/NoItemsCreated/NoItemsCreated'
import notable from "assests/no_table.svg";
import TableCard from 'components/TableCard/TableCard'
import TableCardSkeleton from 'components/TableCard/TableCardSkeleton'

const TablesContainer = ({ handleOpenDialog, loginData, orderSummary, tableListData, isLoading,
    onEdit, onReserve, onBlock, onMerge, onCreateOrder, onViewOrder, onUnblock, onSplit, onRelease, onDelete,
    onGenerateQr, onViewQr
}) => {
    return (
        <ThemeProvider>
            <Box className='order-listing' sx={{ bgcolor: "#fff", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
                <POSHeader />

                <Box>
                    <Container
                        maxWidth={false}
                        disableGutters
                        sx={{
                            // px: { xs: 1, sm: 2, md: 3 },
                            pb: 2,
                            maxWidth: "1400px",
                            mx: "auto",
                        }}
                    >
                        <TablesInfoHeader handleOpenDialog={handleOpenDialog} loginData={loginData} summaryData={orderSummary} isLoading={isLoading} />

                        {isLoading ? (
                            <Box
                                className='d-flex align-items-start justify-content-start tables-card-container'
                                flexWrap="wrap"
                                sx={{ padding: '5px 50px 20px 50px', gap: '20px' }}
                            >
                                {Array.from({ length: 8 }).map((_, index) => (
                                    <TableCardSkeleton key={index} />
                                ))}
                            </Box>
                        ) : tableListData?.length > 0 ? (
                            <>
                                <Box
                                    className='d-flex align-items-start justify-content-start tables-card-container'
                                    flexWrap="wrap"
                                    sx={{ padding: '5px 50px 20px 50px', gap: '20px' }}
                                >
                                    {tableListData.map(table => (
                                        <TableCard
                                            key={table.id}
                                            table={table}
                                            onEdit={() => onEdit(table)}
                                            onReserve={() => onReserve(table)}
                                            onBlock={() => onBlock(table)}
                                            onMerge={() => onMerge(table)}
                                            onSplit={() => onSplit(table)}
                                            onCreateOrder={() => onCreateOrder(table)}
                                            onViewOrder={() => onViewOrder(table)}
                                            onUnblock={() => onUnblock(table)}
                                            onRelease={() => onRelease(table)}
                                            onDelete={() => onDelete(table)}
                                            onGenerateQr={() => onGenerateQr(table)}
                                            onViewQr={() => onViewQr(table)}
                                        />
                                    ))}
                                </Box>
                            </>
                        ) : (
                            <Box sx={{ mt: 3 }}>
                                <NoItemsCreated
                                    img={notable}
                                    title={"No Tables been created, yet!"}
                                    subtitle={"Click on top left button to add your first table and manage your table bookings here."}
                                />
                            </Box>
                        )}
                    </Container>
                </Box>
            </Box>
        </ThemeProvider>
    )
}

export default TablesContainer
